import { create } from 'zustand';
import { api } from './api.js';
import { disconnectAll } from './socket.js';

// كود آخر شركة دخل منها هذا الجهاز — يوفّر على الكاشير كتابته كل مرة.
const COMPANY_KEY = 'kidzo.company';
export const rememberedCompany = () => {
  try { return localStorage.getItem(COMPANY_KEY) || ''; } catch { return ''; }
};
const storeCompany = (slug) => {
  try { if (slug) localStorage.setItem(COMPANY_KEY, slug); } catch { /* ignore */ }
};

export const useAuth = create((set, get) => ({
  user: null,
  company: null,
  permissions: [],
  loading: false,
  ready: false,

  bootstrap: async () => {
    set({ loading: true });
    try {
      const { data } = await api.get('/auth/me');
      set({
        user: data.user || null,
        company: data.company || null,
        permissions: Array.isArray(data.permissions) ? data.permissions : [],
        loading: false,
        ready: true
      });
    } catch {
      set({ user: null, company: null, permissions: [], loading: false, ready: true });
    }
  },

  login: async (username, password, company) => {
    set({ loading: true });
    try {
      const { data } = await api.post('/auth/login', { username, password, company: company || undefined });
      if (data.company && data.company.slug) storeCompany(data.company.slug);
      // Reload via /auth/me to pick up canonical user shape (incl. roleName etc.).
      try {
        const me = await api.get('/auth/me');
        const mePerms = Array.isArray(me.data.permissions) ? me.data.permissions : null;
        const loginPerms = Array.isArray(data.permissions) ? data.permissions : [];
        set({
          user: me.data.user || data.user || null,
          company: me.data.company || data.company || null,
          permissions: mePerms || loginPerms,
          loading: false,
          ready: true
        });
      } catch {
        set({
          user: data.user || null,
          company: data.company || null,
          permissions: Array.isArray(data.permissions) ? data.permissions : [],
          loading: false,
          ready: true
        });
      }
      return data;
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },

  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch {
      // ignore
    }
    try { disconnectAll(); } catch { /* ignore */ }
    set({ user: null, permissions: [] });
  },

  hasPermission: (key) => {
    if (!key) return true;
    const raw = get().permissions;
    const perms = Array.isArray(raw) ? raw : [];
    return perms.includes('*') || perms.includes(key);
  }
}));
